import { useState } from 'react';
import { Palette } from 'lucide-react';

interface ColorPickerCellProps {
  value: string | null;
  onChange: (value: string | null) => void;
  readOnly?: boolean;
}

const PRESET_COLORS = [
  '#00c875', // Verde Monday
  '#0086c0', // Azul
  '#fdab3d', // Laranja
  '#e2445c', // Vermelho
  '#a25ddc', // Roxo
  '#ff158a', // Rosa
  '#ffcb00', // Amarelo
  '#c4c4c4', // Cinza
  '#037f4c', // Verde escuro
  '#9cd326', // Verde limão
  '#00d9ff', // Ciano
  '#784bd1', // Roxo escuro
  '#7f5347', // Marrom
  '#000000', // Preto
  '#ffffff', // Branco
];

export function ColorPickerCell({ value, onChange, readOnly }: ColorPickerCellProps) {
  const [isOpen, setIsOpen] = useState(false);
  
  const selectedColor = value || '#c4c4c4';

  const handleColorSelect = (color: string) => {
    onChange(color);
    setIsOpen(false);
  };

  if (readOnly) {
    return (
      <div className="flex items-center gap-2">
        <div
          className="w-8 h-8 rounded border-2 border-gray-300"
          style={{ backgroundColor: selectedColor }}
        />
        <span className="text-sm font-mono text-gray-600">{selectedColor}</span>
      </div>
    );
  }

  return (
    <div className="relative">
      <div
        className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1 rounded"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div
          className="w-8 h-8 rounded border-2 border-gray-300"
          style={{ backgroundColor: selectedColor }}
        />
        <span className="text-sm font-mono text-gray-600">{selectedColor}</span>
        <Palette className="w-4 h-4 text-gray-400" />
      </div>

      {isOpen && (
        <div className="absolute z-50 mt-2 p-3 bg-white border rounded-lg shadow-lg">
          <div className="grid grid-cols-5 gap-2">
            {PRESET_COLORS.map((color) => (
              <button
                key={color}
                className="w-8 h-8 rounded border-2 hover:scale-110 transition-transform"
                style={{
                  backgroundColor: color,
                  borderColor: color === selectedColor ? '#000' : '#ddd',
                }}
                onClick={() => handleColorSelect(color)}
              />
            ))}
          </div>
          <div className="mt-3 pt-3 border-t">
            <input
              type="color"
              value={selectedColor}
              onChange={(e) => handleColorSelect(e.target.value)}
              className="w-full h-10 cursor-pointer"
            />
          </div>
        </div>
      )}
    </div>
  );
}
